export const AppConstants = {
  appBaseUrl: import.meta.env.VITE_APP_BASE_PATH || "/crm",
  axiosBaseUrl: import.meta.env.VITE_AXIOS_BASE_URL || "/crm",
  defaultDateFormat: "YYYY-MM-DD",
};
